import { Role } from "./enum/role.enum";
import { Terminal } from "./terminal.model";

export class User {

    public id: number;
    public lastname: string;
    public firstname: string;
    public email: string;
    public role: Role;
    public linked: boolean;
    public logged: boolean;
    public createdAt?: string;
    public terminals: Terminal[];
    public commercialTerminals?: Terminal[];
    public supplierNumber?: string;

    constructor(
        id: number,
        lastname: string,
        firstname: string,
        email: string,
        role: Role,
        linked: boolean,
        logged: boolean,
        createdAt?: string,
        terminals: Terminal[] = [],
        commercialTerminals?: Terminal[],
        supplierNumber?: string
    ) {

        this.id = id;
        this.lastname = lastname;
        this.firstname = firstname;
        this.email = email;
        this.role = role;
        this.linked = linked;
        this.logged = logged;
        this.createdAt = createdAt;
        this.terminals = terminals;
        this.commercialTerminals = commercialTerminals || [];
        this.supplierNumber = supplierNumber;
    }

    public getFullName(): string {
        return `${this.firstname[0].toUpperCase() + this.firstname.slice(1)} ${this.lastname[0].toUpperCase() + this.lastname.slice(1)}`;
    }

    public getCreatedAt(): string | null {
        return this.createdAt || null;
    }
}